import { $api } from '~/shared/api';

interface ConfirmCellPhoneResponse {
    error: number;
    Msg: string;
}

export const confirmCellPhone = async (session: string, code: number) => {
    const { data } = await $api.post<ConfirmCellPhoneResponse>('/LinkOrder/LinkOrderApi.php', {
        session,
        code,
    });

    return data;
};
